const doctorDetails = {
    name: "Dr. Yogendra Singh",
    qualification: "MD, DM (Cardiology), FSCAI(USA)",
    hospital: "Associate Director Interventional Cardiology",
    phone: "+91-9411580395",
    registrationNumber: "2337",
    docsign: "dr-yogendra.png", // filename for signature image
  };
  
  export default doctorDetails;